import styled from '@emotion/styled'

/* Container for toggle buttons and checkboxes
 * Centers content and provides consistent spacing
 */
export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 4px;
`
